import React from 'react';
// import SchemeList from '../features/schemes/SchemeList';
import SchemeListNew from '../features/schemes/SchemeListNew';

// import Breadcrumbs from '../components/Breadcrumbs';
import { Container } from 'react-bootstrap';
// import dummySchemes from '../data/dummySchemes';


// className="mt-1"
// schemes={dummySchemes} 
//       <Breadcrumbs />  Raises error

export default function Dashboard({ filters = []}) {
  
  return (
    <div className="container-fluid" >
      <SchemeListNew filters={filters} apiURL='/schemes_fbyids' 
                 isAddToWatchlistApplicable={true}
                 schemeListTitle='Tracked Fund Schemes'/>
    </div>
  );
}
